import * as Yup from 'yup';

export const loginValidationMessages = {
  password: 'Digite sua senha',
  email: 'Digite o endereço de e-mail cadastrado na Trybe',
};

export const loginValidationRules = {
  requiredPassword: Yup.string().required(loginValidationMessages.password),
  requiredEmail: Yup.string()
    .email(loginValidationMessages.email)
    .required(loginValidationMessages.email),
};
